import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Card } from '@/common/components/Card/Card';
import { Grid } from '@/common/components/Grid/Grid';
import { Heading } from '@/common/components/Heading/Heading';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { Stack } from '@/common/components/Stack/Stack';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export function PolicyCoverageCard({ policy }: TPolicyCoverageCardProps) {
  const { t } = useTranslation();
  return (
    <Card plain className="grow">
      <Stack gap="section">
        <Heading level={4}>
          {t('general.labels.yearly_coverages_per_person')}
        </Heading>
        <Grid columnBasis="basis-[24rem]" rowGap="xs" columnGap="lg">
          {policy.product.plan.coverages.map((coverage) => (
            <LabeledValue
              size="sm"
              orientation="horizontal"
              key={coverage.name}
              label={coverage.name}
              value={coverage.value}
            />
          ))}
        </Grid>
        {policy.product.plan.gracePeriod && (
          <BodyText size="sm" color="neutral20">
            {policy.product.plan.gracePeriod}
          </BodyText>
        )}
      </Stack>
    </Card>
  );
}

export type TPolicyCoverageCardProps = {
  policy: IInsurancePolicy;
};
